export { default } from './BlockQuote';
